import script from "./ListInvoicesTable.vue?vue&type=script&lang=ts&setup=true"
export * from "./ListInvoicesTable.vue?vue&type=script&lang=ts&setup=true"

const __exports__ = script;

export default __exports__